import { Component, ElementRef, OnInit, QueryList, ViewChild} from '@angular/core';
import {ProjectsListItemModel} from '../../../../models/projects-list-item.model';
import {ModalDialogV3} from '../../../../../../shared-modal-dynamic/models/modal-dialog-v3';

@Component({
    selector: 'app-devices-table-modal',
    templateUrl: './devices-table-modal.component.html',
    styleUrls: ['./devices-table-modal.component.scss']
})
export class DevicesTableModalComponent extends ModalDialogV3 implements OnInit {


    public model: { project: ProjectsListItemModel, top: number, left: number, marginBottom: number };
    private closingAllowed: boolean;

    @ViewChild('infoPanel', {static: true}) public infoPanelElem: ElementRef;

    public xPosition: number;
    top: string;
    minBottomMargin: number;
    left: string;


    constructor(
    ) {
        super();
    }

    ngOnInit() {
        this.model = <{ project: ProjectsListItemModel, top: number, left: number, marginBottom: number }>this.modalParams.model;
        this.left = this.model.left + 'px';
        this.top = (this.model.top - 33) + 'px';
        this.minBottomMargin = Number.isFinite(this.model.marginBottom) ? this.model.marginBottom : 10;
        this.fixBottomMargin();
    }

    public close() {
        super.close();
    }

    onMouseMove(event) {
        if (!this.xPosition) {
            this.xPosition = event.screenX;
        }
        const delta = Math.abs(this.xPosition - event.screenX);
        if (delta > 15) {
            this.closingAllowed = true;
            // to avoid after-click reopening the dialog closing is not allowed until mouse is moved enough
        }
    }

    onKeepDialogOpenAreaClicked() {
        if (this.closingAllowed) {
            this.close();
        }
    }

    // move window to be fully visible if is partially hidden behind window edge
    private fixBottomMargin() {
        setTimeout(_ => {
            // called via timeout after table will be rendered on the screen
            const windowHeight = window.innerHeight;
            const rect = this.infoPanelElem.nativeElement.getBoundingClientRect();
            // console.log('=====rect top', rect.top );

            if (rect.bottom + this.minBottomMargin > windowHeight) {

                let newTop = (windowHeight - rect.height - 33  - this.minBottomMargin);

                // console.log('newTop', newTop  );
                if ( (rect.top - newTop) < (2 * 33) ) {

                    newTop = rect.top - (2 * 33);
                }
                this.top = newTop + 'px';
                // console.log('moved', rect.top - newTop );
            }

        }, 0);
    }
}
